import { APIParser, APIDownloadFile } from "./api-parser";
import { NEW_API_URL } from "./api-client";
import { getToken } from "./api-util";

/* Log Activity Gets */

export const GetLogActivity = (logActivityID) => {
  return fetch(NEW_API_URL + "LogActivity/GetActivityLog/" + logActivityID, {
    method: "POST",
    credentials: "include",
  }).then((response) => APIParser(response));
};

export const GetAllLogActivities = (searchQuery) => {
  let searchQueryJSON = JSON.stringify(searchQuery);

  return fetch(NEW_API_URL + "LogActivity/GetAllLogs/", {
    method: "POST",
    body: searchQueryJSON,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => APIParser(response));
};

export const GetMostRecentLogs = (searchQuery) => {
  let searchQueryJSON = JSON.stringify(searchQuery);

  return fetch(NEW_API_URL + "LogActivity/GetMostRecentLogs/", {
    method: "POST",
    body: searchQueryJSON,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => APIParser(response));
};

export const DownloadLogActivity = () => {
  let token = getToken();
  return fetch(NEW_API_URL + "LogActivity/DownloadLogs/", {
    method: "GET",
    credentials: "include",
    headers: { Authorization: `Bearer ${token}` },
  }).then((response) => APIDownloadFile(response));
};
